import React from 'react';
import AuthenticationContext from './contexts/AuthenticationContext';

const withAuthentication = (WrappedComponent) => {

    return class extends React.Component {

        render() {

            return (

                <AuthenticationContext.Consumer>
                    {auth => <WrappedComponent auth={auth} {...this.props}/>}
                </AuthenticationContext.Consumer>
            );
        }

    };
};

export default withAuthentication;



// WEBPACK FOOTER //
// ./src/components/withAuthentication.js